import { AppLayout } from "../shared";
import MasterOrgAdvertisements from "../MasterOrg/MasterOrgAdvertisements";

const MasterOrgAdvertisements_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <MasterOrgAdvertisements props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgAdvertisements_layout;
